/* screens/settings/SettingsScreen.jsx — оболочка раздела «Аккаунт» (window.SettingsScreen).
   Под-вкладки адресуемы deep-link через ?tab= (Профиль/Тариф/Для бизнеса/Уведомления/
   Безопасность). Подвкладки бизнеса — &biz=tariff|restaurant|knowledge|team.
   Профиль заведения и база знаний — внутри «Для бизнеса» (раздел /restaurant убран,
   легаси-ссылки редиректит routes.jsx).
   Редирект ?tab=team → ?tab=business&biz=team (фикс №6).
   Desktop (≥1680): вертикальный sidebar-rail + контент; ≤720: PageHeader-табы (ScrollRow).
   Контент не растягивается на 4k (clamp). // источник: 11 §2.1.
   ХЕНДОФФ → frontend/pages/settings/Settings.jsx. */

import React from 'react';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { PageHeader } from '../../components/patterns/PageHeader.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { hooks } from '../../hooks/index.jsx';
import { RR } from '../../lib/router.jsx';
import { BusinessSection } from './BusinessSection.jsx';
import { NotificationsTab } from './NotificationsTab.jsx';
import { SettingsProfileTab } from './ProfileTab.jsx';
import { SecurityTab } from './SecurityTab.jsx';
import { SubscriptionTab } from './SubscriptionTab.jsx';

  const { useEffect } = React;
  const { useSearchParams } = RR;
  const { useBreakpoint } = hooks;

  function SettingsScreen() {
    const [params, setParams] = useSearchParams();
    const { isMobile } = useBreakpoint();
    const { activeWorkspace } = useAuth();

    let tab = params.get('tab') || 'profile';
    const biz = params.get('biz') || 'tariff';

    // редирект ?tab=team → ?tab=business&biz=team (легаси deep-link, фикс №6)
    useEffect(() => {
      if (params.get('tab') === 'team') {
        setParams((prev) => { const sp = new URLSearchParams(prev); sp.set('tab', 'business'); sp.set('biz', 'team'); return sp; }, { replace: true });
      }
    }, [params, setParams]);
    if (tab === 'team') tab = 'business';

    const tabs = [
      { id: 'profile', label: 'Профиль', icon: 'user' },
      // «Тариф» и «Для бизнеса» не говорили, ЧТО именно оплачивается: ресторан
      // читал первое как «тариф вообще», покупал личного ассистента и не получал
      // аналитику. На проде так разошлись 27 личных оплат против 16 бизнесовых.
      { id: 'subscription', label: 'Личный тариф', icon: 'credit-card' },
      { id: 'business', label: 'Заведения', icon: 'building' },
      { id: 'notifications', label: 'Уведомления', icon: 'notifications' },
      { id: 'security', label: 'Безопасность', icon: 'lock' },
    ];
    if (!tabs.some((t) => t.id === tab)) tab = 'profile';

    const goTab = (id) => setParams((prev) => {
      const sp = new URLSearchParams(prev);
      sp.set('tab', id);
      if (id !== 'business') sp.delete('biz');
      return sp;
    });
    const onBiz = (value) => setParams((prev) => {
      const sp = new URLSearchParams(prev); sp.set('tab', 'business'); sp.set('biz', value); return sp;
    });

    const renderTab = () => {
      switch (tab) {
        case 'profile':       return <SettingsProfileTab />;
        case 'subscription':  return <SubscriptionTab searchParams={params} />;
        case 'business':      return <BusinessSection biz={biz} onBiz={onBiz} searchParams={params} />;
        case 'notifications': return <NotificationsTab />;
        case 'security':      return <SecurityTab />;
        default:              return <SettingsProfileTab />;
      }
    };

    return (
      <div className="section-page settings-page" data-screen-label="Аккаунт">
        <PageHeader subtitle="Аккаунт" title="Настройки"
          tabs={isMobile ? tabs : undefined} activeTab={tab} onTab={goTab} />
        <div className="section-body settings-body">
          {!isMobile && (
            <nav className="settings-rail" aria-label="Разделы настроек">
              {tabs.map((t) => (
                <button key={t.id} type="button"
                  className={'settings-rail__item' + (tab === t.id ? ' is-active' : '')}
                  aria-current={tab === t.id ? 'page' : undefined}
                  onClick={() => goTab(t.id)}>
                  <Icon name={t.icon} size={18} />
                  <span>{t.label}</span>
                </button>
              ))}
            </nav>
          )}
          {/* key по активному ws → при смене пространства контент перемонтируется
              и все вкладки перезапрашивают актуальные данные нового пространства. */}
          <div className="settings-content" key={activeWorkspace ? activeWorkspace.id : 'none'}>{renderTab()}</div>
        </div>
      </div>
    );
  }

export { SettingsScreen };
